<template>
  <VDialogBox
    :visible="visible"
    :show-close="false"
    class="widget-dialog"
    @close="handleClose"
  >
    <keep-alive>
      <div
        v-if="visible"
        class="widget-scroll-container"
      >
        <Widgets
          :name="widget"
          :event-id="eventId"
          :sport-id="sportId"
        />
      </div>
    </keep-alive>

    <button
      class="m-pop-close-btn"
      @click.stop="handleClose"
    >
      <svg-icon icon-class="icon-close-round" />
    </button>
  </VDialogBox>
</template>

<script>
import VDialogBox from 'fe-vui/dialogBox'
import modalHelper from '@ms/utils/scroll-fixed'
import Widgets from './index.vue'
import 'base/icons/svg/close-round.svg'

export default {
  name: 'DialogWidget',
  components: {
    VDialogBox,
    Widgets
  },
  model: {
    prop: 'visible',
    event: 'close'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    widget: {
      type: String,
      default: ''
    },
    eventId: {
      type: String,
      default: ''
    },
    sportId: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          modalHelper.afterOpen()
        })
      }
    }
  },
  mounted() {
    if (this.visible) {
      modalHelper.afterOpen()
    }
  },
  methods: {
    handleClose() {
      modalHelper.beforeClose()
      this.$emit('close')
    }
  }
}
</script>

<style lang="less">
.widget-dialog {
  .dialog {
    background: transparent;
  }

  .m-pop-close-btn {
    position: absolute;
    bottom: -60px;
    left: 50%;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    transform: translateX(-50%);

    .svg-icon {
      color: #939393;
      font-size: 40px;
      line-height: 1;
    }
  }
}

.widget-scroll-container {
  overflow: scroll;
  height: 60vh;
  background: #323232;

  .m-widgets {
    min-height: 100%;
  }
}
</style>
